import store from '../redux/store/store';
import {showLoader,hideLoader} from '../redux/slices/settingsSlice';
import axios from 'axios';
import { ErrorToast } from '../helper/formHelper';
import {BaseURL} from '../helper/config';
import { setProductsList, setSingleProduct, setTotalProducts } from '../redux/slices/productSlice';

export async function productListApi(pageNo, perPage, searchKeyword) {
    try {
        store.dispatch(showLoader())
        let URL = BaseURL+"/productsList/"+pageNo+"/"+perPage+"/"+searchKeyword;
        const result = await axios.get(URL)
        store.dispatch(hideLoader())
        if (result.status === 200 && result.data['status'] === "success") {
            if (result.data['data'][0]['Rows'].length > 0) {
                store.dispatch(setProductsList(result?.data['data'][0]['Rows']))
                store.dispatch(setTotalProducts(result?.data['data'][0]['Total'][0]['count']))
            } else {
                store.dispatch(setProductsList([]))
                store.dispatch(setTotalProducts(0))
                ErrorToast("No Data Found")
            }
        } else {
            ErrorToast("Something Went Wrong")
        }
    }
    catch (e) {
        ErrorToast("Something Went Wrong")
        store.dispatch(hideLoader())
    }
}


export async function productDetailsById(id) {
    try {
        store.dispatch(showLoader())
        let URL = BaseURL+"/productDetailsById/"+id;
        const result = await axios.get(URL)
        store.dispatch(hideLoader())
        if (result.status === 200 && result.data['status'] === "success") {
            store.dispatch(setSingleProduct(result?.data['data'][0]))
            // store.dispatch(setInitialImage(result?.data['data'][0]['images'][0]))
        } else {
            store.dispatch(setSingleProduct({}))
            // store.dispatch(setInitialImage(""))
            ErrorToast("Something Went Wrong. Try Again!")
        }
    }
    catch (e) {
        ErrorToast("Something Went Wrong")
        store.dispatch(hideLoader())
    }
}